import { TAX_FORM } from './form-tax-types';
import { showToast } from '../../toasts';
import { checkForSelectValue } from '../form-helpers';

import PostNewTax from '../../../routes/post-new-tax';

/**
 * Function to post a new tax
 * 
 * @returns void
 */
const AddNewTax = async () => {
  if ( !TAX_FORM.txForm ) return;

  const { txForm, txType, txPartner, txName, txAmount, txSubmitButton } = TAX_FORM;

  const validateForm = () => {
    txForm.classList.add('was-validated');

    checkForSelectValue(txType, 'Tax Type', 'tax-type');
    if ( txPartner ) {
      checkForSelectValue(txPartner, 'Partner', 'partner');
    }

    const isValid = (txType ? txType.getAttribute('data-value') != null : false) && 
                  (txPartner ? txPartner.getAttribute('data-value') != null : true);

    return txForm.checkValidity() && isValid;
  }

  const handleNewTax = async (awsData: any) => {
    const { body } = await PostNewTax(awsData);

    if ( body ) {
      showToast('aafp_toast', `${txName.value} group has been added`);
      setTimeout(() => {
        location.href = '/terminal-taxes/';
      }, 1500);
    }
  }

  txForm.addEventListener('submit', event => {
    event.preventDefault();
    event.stopPropagation();

    if ( validateForm() ) {
      txForm.classList.remove('form-control:valid');
      txSubmitButton.classList.add('aafp_button-loading');

      const awsJsonData = {
        taxName: txName.value,
        taxAmount: txAmount.valueAsNumber,
        taxType: String(txType.getAttribute('data-value')),
        partnerID: Number(txPartner.getAttribute('data-value'))
      }

      handleNewTax(awsJsonData);
    }
  });
}

export default AddNewTax;